import { HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class InterceptorService {
    private cachedToken: string | null = null;

    private readonly publicApiEndpoints: string[] = [
        'login',
        'register',
        'resend/otp',
        'verify/otp',
        'password/reset',
        'password/update',
        'initial',
        'banners',
        'pages',
        'areas',
        'subscriptions',
        'menu_items',
        'celebrities',
        'posts',
        'calculate/calories',
        'order'
    ];

    constructor(private authService: AuthService) {
        this.authService.currentUser$.subscribe(() => {
            this.cachedToken = this.authService.getAuthToken();
        });
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.cachedToken || this.authService.getAuthToken();
        
        const headers: any = {
            'identifier': environment.IDENTIFIER,
            'accept': 'application/json'
        };
        
        if (token && token !== '') {
            headers['Authorization'] = `${token}`;
        }
        
        req = req.clone({ setHeaders: headers });

        return next.handle(req).pipe(
            switchMap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    const body = event.body;
                    if (body?.code === 401 || (body?.success === false && body?.message === 'Unauthorized.')) {
                        if (this.isAuthenticatedEndpoint(req.url)) {
                            console.log('[Interceptor] Response body indicates 401, logging out');
                            this.cachedToken = null;
                            this.authService.logOutUser();
                            return throwError(() => new HttpErrorResponse({
                                error: body,
                                status: 401,
                                statusText: 'Unauthorized',
                                url: req.url
                            }));
                        }
                    }
                }
                return of(event);
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 && this.isAuthenticatedEndpoint(req.url)) {
                    this.cachedToken = null;
                    this.authService.logOutUser();
                }
                return throwError(() => error);
            })
        );
    }

    private isAuthenticatedEndpoint(url: string): boolean {
        const urlPath = url.replace(environment.API_URL, '').split('?')[0];
        return !this.publicApiEndpoints.some(endpoint => urlPath === endpoint || urlPath.startsWith(endpoint + '/'));
    }
}
